import { FilterFormFields } from '../enums/filter-field.enum';

export const DEFAULT_FILTER_CONFIG = {
    [FilterFormFields.RECEIVED_READ]: true,
    [FilterFormFields.RECEIVED_UNREAD]: true,
    [FilterFormFields.SENT_READ]: true,
    [FilterFormFields.SENT_UNREAD]: true,
};
export const FEATURE_MENU_NAME = 'featureMenu';
